import { h, Component } from "preact";
import actions from "../../actions";
import { connectWithTranslations } from "../../../common/helpers/translationsHelpers";
import { isPast } from "../../../common/helpers/dateHelpers";
import EventTime from "./EventTime";
import { GTM_ID, GA4EVENT } from "../../constants";
import renderNumerical from "../../helpers/render";
import IconBellSolid from "../../../common/components/icons/IconBellSolid";
import IconBell from "../../../common/components/icons/IconBell";
import IconLocked from "../../../common/components/icons/IconLocked";
import { enabledCalendarNotifications } from "../../../calendar-common/helpers/calendar";
import SpeechScore from "./SpeechScore";
import { CALENDAR_VIEW } from "../../../calendar-common/constants";
import eventTimeCheck from "../../helpers/eventTimeCheck";
import { getSpeechScore } from "../../helpers/getSpeechScore";

class EventRowDataMobile extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isPastEvent: isPast(props.event.date, props.settings.timezoneOffset),
        };
    }
    renderTradeNow(config, eventdate) {
        try {
            return (
                <span>
                    &nbsp;
                    <span
                        dangerouslySetInnerHTML={{
                            __html: config.tradeNowFnc(eventdate),
                        }}
                    ></span>
                </span>
            );
        } catch (ex) {
            console.log("tradNowFunc", ex);
        }
    }

    getOneColumnLabelText(isSpeech, isReport, isInProgress) {
        return isSpeech
            ? isInProgress
                ? "InProgress"
                : "RowSpeech"
            : isReport
            ? "RowReport"
            : "RowAllDay";
    }

    renderOneColumnData(isSpeech, labelText, translate, speechScore, isInProgress) {
        if (speechScore?.isLocked) {
            return (
                <span className="fxs_c_label fxs_c_label_info_background fxs_c_label_locked">
                    <span class="fxs_c_label_locked_icon">
                        <IconLocked />
                    </span>
                </span>
            );
        }

        if (!isSpeech || !speechScore) {
            return (
                <span
                    className={`fxs_c_label ${
                        isInProgress
                            ? "fxs_c_label_info_base"
                            : "fxs_c_label_info_background"
                    }`}
                >
                    <span>{translate(labelText)}</span>
                </span>
            );
        }

        return (
            <SpeechScore
                speechScore={speechScore}
                forceUpperCase={true}
                hideScoreNumber={true}
            />
        );
    }

    render(
        {
            event,
            translate,
            showDetailsClick,
            renderName,
            config,
            isSubscribed,
            subscribeToEvent,
            unsubscribeToEvent,
            eventTimeReached,
        },
        { isPastEvent }
    ) {
        const {
            id,
            date,
            countryCode,
            currencyCode,
            speech,
            isSpeech,
            isReport,
            isAllDay,
            isTentative,
            isPreliminary,
            actual,
            volatility,
            potency,
            unit,
            isBetterThanExpected,
            eventId,
            isScoreTrackable,
        } = event;

        let speechScore = null;

        const hasScore = speech?.score ?? false;
        const hasAverageScore = speech?.averageScore ?? false;

        const isSpeechScoreEnabled = config.enableSpeechScore;
        const isInProgress =
            !hasScore && isScoreTrackable && eventTimeReached && isSpeechScoreEnabled;

        const prefix = unit !== "%" ? unit : null;
        const percentage = unit === "%" ? "%" : null;

        const isOneColumn = isSpeech || isReport || isAllDay;
        const showEventTime = !isTentative || actual !== null;

        if (isSpeech && isSpeechScoreEnabled && (hasScore || hasAverageScore)) {
            speechScore = getSpeechScore(event);
            if (speechScore) speechScore.isLocked = config.isLocked();
        }

        return (
            <tr
                data-event-date-id={id}
                class={`fxs_c_row ${isPastEvent ? "fxs_c_now" : ""}`}
                onClick={showDetailsClick}
                data-gtmid={config.tracking && GTM_ID.OPEN_OVERVIEW(id)}
                data-ga4event-clk-name={
                    config.tracking && GA4EVENT.NAMES.FEATURES_CALENDAR
                }
                data-ga4event-element={config.tracking && GA4EVENT.ELEMENTS.OPEN_OVERVIEW}
                data-ga4event-eventdateid={id}
            >
                <td class="fxs_c_item fxs_c_time">
                    {showEventTime ? (
                        <EventTime
                            date={date}
                            onEventHappened={() => this.setState({ isPastEvent: true })}
                            hasActual={actual !== null}
                        />
                    ) : (
                        translate("RowNotAvailable")
                    )}
                    <br />
                    <span className="fxs_nowrap">
                        <span
                            class={`fxs_flag ${
                                countryCode ? "fxs_" + countryCode.toLowerCase() : ""
                            }`}
                        ></span>
                        <strong>{currencyCode}</strong>
                    </span>
                </td>
                <td class="fxs_c_item fxs_c_name">
                    <span>{renderName(event)}</span>
                    {isPreliminary && (
                        <span class="fxs_c_preliminary">
                            {" "}
                            {translate("RowPreliminaryAbbreviation")}{" "}
                        </span>
                    )}
                    {config.tradeNowFnc !== null && this.renderTradeNow(config, event)}
                </td>
                <td class="fxs_c_item fxs_c_impact">
                    <span
                        class={`fxs_c_impact-icon ${
                            volatility
                                ? "fxs_c_impact-" + volatility.toLowerCase()
                                : "fxs_c_impact-none"
                        }`}
                    ></span>
                </td>
                {isOneColumn && (
                    <td class="fxs_c_item fxs_c_type">
                        {this.renderOneColumnData(
                            isSpeech,
                            this.getOneColumnLabelText(isSpeech, isReport, isInProgress),
                            translate,
                            speechScore,
                            isInProgress
                        )}
                    </td>
                )}
                {!isOneColumn && (
                    <td class="fxs_c_item fxs_c_actual">
                        {
                            <strong
                                class={
                                    typeof isBetterThanExpected === "boolean"
                                        ? isBetterThanExpected
                                            ? "fxs_c_positive"
                                            : "fxs_c_negative"
                                        : ""
                                }
                            >
                                {renderNumerical(
                                    actual,
                                    prefix,
                                    percentage,
                                    potency,
                                    translate
                                )}
                            </strong>
                        }
                    </td>
                )}
                <td
                    class={`fxs_c_item fxs_c_notify ${
                        isSubscribed && enabledCalendarNotifications(config)
                            ? "fxs_c_notify_active"
                            : ""
                    }`}
                    onClick={(e) => {
                        e.stopPropagation();
                        if (isSubscribed) unsubscribeToEvent(eventId);
                        else {
                            subscribeToEvent(eventId);
                        }
                    }}
                >
                    {isSubscribed && enabledCalendarNotifications(config) ? (
                        <IconBellSolid />
                    ) : (
                        <IconBell />
                    )}
                </td>
            </tr>
        );
    }
}

export default connectWithTranslations(
    "config,settings,eventDateDetailMinimalShown",
    actions
)(eventTimeCheck(EventRowDataMobile));
